// extracted by css-extract-rspack-plugin
export default {"MultiSelectInput":"MultiSelect-module__MultiSelectInput___D88EN"};